// extracted by mini-css-extract-plugin
export default {"disabledRow":"cabinetDetails_disabledRow__n-FTt","uploadContainer":"cabinetDetails_uploadContainer__3Wl97","uploadIcon":"cabinetDetails_uploadIcon__x1w6N"};